import { Alert } from "reactstrap";
import DateTimeText from "../../../../../components/DateTimeText";

export function ExportStatesTable({ states }: { states: any[] })
{
    if (!states || states.length === 0)
    {
        return <Alert color="info">Brak stanów eksportu dla podanych kryteriów.</Alert>;
    }

    return (
        <div className="table-responsive mt-3">
            <table className="table table-sm table-bordered mb-0">
                <thead>
                    <tr>
                        <th>Produkt</th>
                        <th>Profil</th>
                        <th>Status</th>
                        <th>Operacja</th>
                        <th>Current hash</th>
                        <th>Exported hash</th>
                        <th>Prepared</th>
                        <th>Exported</th>
                        <th>Komunikat</th>
                        <th>Błąd</th>
                    </tr>
                </thead>
                <tbody>
                    {states.map((state, index) => (
                        <tr key={`${state.productId}-${state.profileId}-${index}`}>
                            <td>{state.productId}</td>
                            <td><code>{state.profileId}</code></td>
                            <td>{state.status}</td>
                            <td>{state.desiredOperation}</td>
                            <td>{state.currentPayloadHash ? <code>{state.currentPayloadHash}</code> : <span className="text-muted">—</span>}</td>
                            <td>{state.exportedPayloadHash ? <code>{state.exportedPayloadHash}</code> : <span className="text-muted">—</span>}</td>
                            <td><DateTimeText value={state.preparedAt} /></td>
                            <td><DateTimeText value={state.exportedAt} /></td>
                            <td>{state.lastMessage || <span className="text-muted">—</span>}</td>
                            <td>{state.lastError ? <span className="text-danger">{state.lastError}</span> : <span className="text-muted">—</span>}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}